import { ValidatorInput } from '../validation/validation-descriptor.entity';
import { UserValidator } from '../validation/validation.user';
import { ChangeUserDataRequest, UserData } from '../../../generated/api/kreditportalBackendAPI.schemas';
import { ValidationChecks } from '../validation/validation-checks.enum';
import { Validator } from '../validation/validator.util';
import { ValidationError } from '../validation/validation.error';

export class UserChangeModel {

    private readonly checkPassword = (field: ValidatorInput) => {
        UserValidator.validateAndDoubleCheckPw(field, this.passwordConfirm);
    };

    private readonly checkEmail = (field: ValidatorInput) => {
        field.valid = true;

        if (field.value.toLowerCase() !== this.emailConfirm.value.toLowerCase()) {
            field.errorMsg = 'E-Mail-Adresse und E-Mail-Adresse-Wiederholung stimmen nicht &uuml;berein.';
            field.valid = false;
        }

        if (!UserValidator.validateEmail(field.value)) {
            field.errorMsg = 'Die eingegebene E-Mail-Adresse ist nicht g&uuml;ltig.';
            field.valid = false;
        }
    };

    private readonly checkVornameUndNachname = (field: ValidatorInput) => {
        field.valid = true;

        if (!this.vorname.value && !this.nachname.value) {
            field.errorMsg = 'Entweder Vorname oder Name muss eingegeben werden.';
            field.valid = false;
        }
    };

    userData: UserData;

    uid: string;

    vorname = new ValidatorInput(
        'vorname',
        '',
        'Vorname',
        /^\w+$/,
        null,
        false,
        0,
        this.checkVornameUndNachname
    );

    nachname = new ValidatorInput(
        'nachname',
        '',
        'Name',
        /^\w+$/,
        null,
        false,
        0,
        this.checkVornameUndNachname
    );

    passwordOld = new ValidatorInput(
        'password',
        '',
        'Passwort',
        /^.$/,
        null,
        false,
        ValidationChecks.NOT_EMPTY_CHECK
    );

    password = new ValidatorInput(
        'password',
        '',
        'Passwort',
        /^.$/,
        null,
        false,
        ValidationChecks.NOT_EMPTY_CHECK,
        this.checkPassword,
    );

    passwordConfirm = '';

    email = new ValidatorInput(
        'email',
        '',
        'E-Mail-Adresse',
        /^.$/,
        null,
        false,
        ValidationChecks.NOT_EMPTY_CHECK,
        this.checkEmail,
    );

    emailConfirm = new ValidatorInput(
        'emailConfirm',
        '',
        'E-Mail-Adresse wiederholen',
        /^.$/,
        null,
        false,
        ValidationChecks.NOT_EMPTY_CHECK,
        UserValidator.validateSingleEmail,
    );

    collection: ValidatorInput[] = [
        this.vorname,
        this.nachname,
        this.email,
        this.emailConfirm,
        this.passwordOld,
        this.password,
    ];

    validateField(field: ValidatorInput) {
        field.valid = Validator.doValidate(field, 1, []);
    }

    validate(untilLabel = 'never stop(dummy)'): ValidationError[] {
        const result: ValidationError[] = [];

        Validator.doValidate(this.vorname, 1, result);
        Validator.doValidate(this.nachname, 1, result);

        if (   this.userData.email.value !== this.email.value
            || (this.emailConfirm.value && this.userData.email.value !== this.emailConfirm.value)
        ) {
            Validator.doValidate(this.email, 1, result);
            Validator.doValidate(this.emailConfirm, 1, result);
            Validator.doValidate(this.passwordOld, 1, result);

            this.validateField(this.passwordOld);
            if (!this.passwordOld.valid) {
                this.passwordOld.errorMsg = 'Zur Änderung der Mailadresse bitte das aktuelle Passwort eingeben.';
            }
        }

        return result.length === 0 ? null : result;
    }

    toKey(): string {
        return 'UserChangeModel';
    }

    isCachable(): boolean {
        return false;
    }

    createRequest = (): ChangeUserDataRequest => {
        const request: ChangeUserDataRequest = {
            uid: this.uid
        };

        const nameChanged = this.userData.name.value !== this.vorname.value;
        const surnameChanged = this.userData.surname.value !== this.nachname.value;

        // Backend (UserService.changeUserData) erwartet bei Namensänderung sowohl getName() als auch
        // getSurname() als TypedChangingEntity, da fullname aus beiden zusammengesetzt wird.
        if (nameChanged || surnameChanged) {
            request.name = {
                oldValue: this.userData.name.value,
                recentValue: this.vorname.value,
                changed: nameChanged,
            };
            request.surname = {
                oldValue: this.userData.surname.value,
                recentValue: this.nachname.value,
                changed: surnameChanged,
            };
        }

        const emailChanged = this.emailConfirm.value.length !== 0
            && this.userData.email.value !== this.email.value;

        if (emailChanged) {
            request.email = {
                oldValue: this.userData.email.value,
                recentValue: this.email.value,
                changed: true,
            };
            // Aktuelles Passwort wird benötigt, da bei E-Mail-Änderung im Backend
            // eine erneute Authentifizierung gegen Keycloak erfolgt.
            request.password = {
                oldValue: this.passwordOld.value,
                changed: false,
            };
        }

        return request;
    };

}
